import Vue from 'vue';
import Transitions from 'vue2-transitions';
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';
import { Integrations } from '@sentry/tracing';
import ElementUI from 'element-ui';
import { MediaQueries } from 'vue-media-queries';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/fr';
import VueIntro from 'vue-introjs';
import 'intro.js/introjs.css';
import { ShopAuthManager, ShopSessionManager } from '@holdingblachere/js-sdk';
import { ShopLoginPlugin, AdminLoginPlugin } from '@holdingblachere/vue-common-ui';
import '@holdingblachere/vue-common-ui/dist/mb-vue-common-ui.css';

import App from './App.vue';
import router from './router';
import store from './store';
import { csvUtils } from './utils/utils';
// i18n
import i18n from './i18n/i18n';

// Firebase
import './vendors/firebase/firebase';

// Mixpanel
import mixpanel from './vendors/mixpanel/mixpanel';

Vue.config.devtools = true;

const shopAuthManager = new ShopAuthManager({
  AMCBackendUrl: process.env.VUE_APP_MON_COMPTE_BACKEND_URL,
});

Vue.use(ShopLoginPlugin, {
  router,
  shopAuthProvider: shopAuthManager,
  store,
});

const shopSessionManager = new ShopSessionManager({
  url: process.env.VUE_APP_MARKETPLACE_BACKEND_URL,
});

Vue.use(AdminLoginPlugin, {
  shopSessionManager,
  afterLoginRoute: 'Dashboard',
  loginWithCustomTokenAction: 'auth/loginWithCustomToken',
});

Vue.prototype.$mixpanel = mixpanel;
Vue.use(VueIntro);
Vue.use(Transitions);
Vue.use(ElementUI, { locale });

Vue.config.productionTip = false;

const mediaQueries = new MediaQueries();

Vue.use(mediaQueries);

Sentry.init({
  dsn: process.env.SENTRY_DSN,
  integrations: [
    new VueIntegration({
      Vue,
      tracing: true,
    }),
    new Integrations.BrowserTracing(),
  ],
  tracesSampleRate: 1,
});


new Vue({
  router,
  store,
  csvUtils,
  i18n,
  mediaQueries,
  render: (h) => h(App),
}).$mount('#app');
